import classNames from 'classnames';
import { motion } from 'motion/react';
import { Text } from '@querodelivery/uni-react';
import styles from './mission-progress-bar.module.scss';

interface MissionProgressBarProps {
  value: number;
  accessibilityLabel?: string;
  className?: string;
}

export const MissionProgressBar = ({
  value,
  accessibilityLabel,
  className,
}: MissionProgressBarProps) => {
  const percentage = value ? Math.min(100, Math.max(0, value)) : 0;

  return (
    <div className={styles.container}>
      <Text variant="headingLg" tone="supporting" fontWeight="bold">
        {percentage.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%
      </Text>
      <div
        className={classNames(styles.track, className)}
        role="progressbar"
        aria-valuenow={percentage}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={accessibilityLabel}
      >
        <motion.div
          className={styles.fill}
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        />
      </div>
    </div>
  );
};
